import React, { useEffect, useRef, useState, useCallback } from 'react';
import Aos from 'aos';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { api_url } from '../config';
import { useSelector } from 'react-redux';
import { MutatingDots } from 'react-loader-spinner';
import api from '../utils/api';
import PromoCard from '../components/PromoCard';
import ScrollToTop from '../components/ScrollToTop';
import ProductList from '../components/Products/ProductList';
import PlanComponent from '../components/Products/PlanComponent';
import { products } from '../data/productData';
import { capitalizeFirstLetter } from '../utils/helpers';

const AuthProductPage = () => {
    const [activeProduct, setActiveProduct] = useState('pharmtrix-wholesale');
    const [planData, setPlanData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { id, token } = useSelector((state) => state.auth);
    const promoRef = useRef();

    useEffect(() => {
        Aos.init({
            offset: 100,
            duration: 600,
            easing: 'ease-in-sine',
            delay: 100,
        });
    }, []);

    const fetchPlanData = useCallback(async (productTitle) => {
        setLoading(true);
        setPlanData(null);

        const params = {
            page: 1,
            limit: 50,
            [`filter[app]`]: productTitle,
        };
        
        try {
            const response = await api.get(api_url + `/v1/user/${id}/plans`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }, 
                params
            });
            const data = response.data.data;
            setPlanData(data);
        } catch (error) {
            console.error("Error fetching plans:", error);
        } finally {
            setLoading(false);
        }
    }, [id, token]);

    const handleProductClick = (productTitle) => {
        setActiveProduct(productTitle);
    };

    useEffect(() => {
        fetchPlanData(activeProduct);
    }, [activeProduct, fetchPlanData]);

    return (
        <div className="mx-auto px-3 sm:px-4 pb-6">
            <div className="text-white">
                <header className="text-center mt-6 mb-8 sm:my-12" data-aos="zoom-in">
                    <h1 className="text-2xl sm:text-4xl font-semibold mb-3">
                        Elevate your Clinical & business operations
                    </h1>
                    <p className="text-sm sm:text-base opacity-90 mx-auto max-w-2xl">
                        Explore our healthcare products engineered to optimize your operations
                    </p>
                </header>
                
                <PromoCard promoRef={promoRef} />
                
                <ProductList 
                    products={products} 
                    activeProduct={activeProduct} 
                    onProductChange={handleProductClick} 
                />
            </div>

            <div className="mt-4">
                <h2 className="text-xl font-bold mb-2 text-center text-white">
                    {capitalizeFirstLetter(activeProduct)} Plans
                </h2>

                <div className="mt-2">
                    {loading ? (
                        <div className="h-40 flex justify-center items-center">
                            <MutatingDots
                                visible={true}
                                height="60"
                                width="60"
                                color="#4fa94d"
                                secondaryColor="#4fa94d"
                                radius="12.5"
                                ariaLabel="mutating-dots-loading"
                            />
                        </div>
                    ) : (
                        <PlanComponent 
                            planData={planData} 
                            promoRef={promoRef} 
                            isAuthenticated={true} 
                        />
                    )}
                </div>
                <ScrollToTop />
            </div>
        </div>
    );
};

export default AuthProductPage;